var DEGREE = 180 / Math.PI;
var toDegree = function (radian) {
  return DEGREE * radian;
};
export default toDegree;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/to-degree.js
// module id = 74
// module chunks = 0